import { Component }      from '@angular/core';
import { NavController }  from 'ionic-angular';
import { Mixture }        from '../../shared/models/mixture';
import { NavParams }      from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

@Component({
  selector:    'page-mixtures-result',
  templateUrl: 'mixtures-result.html'
})

export class MixturesResultPage
{
  mixtures      : Mixture[]  = [];
  mixture       : Mixture    = null
  moleculeCompo : string     = "";
  alEquiv       : string     = "";

  constructor(public navCtrl    : NavController,
              public navParams  : NavParams,
              private analytics  : GoogleAnalytics)
  {
      this.mixture       = this.navParams.get('item');
      this.moleculeCompo = this.navParams.get('moleculeCompo');
      this.alEquiv       = this.navParams.get('alEquiv');
      this.mixtures      = this.navParams.get('equivalent');
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Mixtures results " + this.mixture.Name);
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/mixtures-result/mixtures-result.ts